import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/app/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EcitationReportService {

  url = environment.apiUrl
  constructor(private http:HttpClient) { }

  getdeliveryAnnualReport(year:any){
    
    return this.http.get(this.url+`/ecitation-services/report/deliveryAnnualReport/?year=${year}`)
  }
  getdeliverySummaryReport(year:any){
  
    return this.http.get(this.url+`/ecitation-services/report/deliverySummaryReport`)

  }
  getAgencyAnnualReport(year:any){
  
    return this.http.get(this.url+`/ecitation-services/report/agencyAnnualReport?year=${year}`)

  }
  
  getAgencySummaryReport(start:any,end:any){
  
    return this.http.get(this.url+`/ecitation-services/report/agencySummaryReport/?startDate=${start}&endDate=${end}`)
  }
  getDayOfWeekReport(){
  
    return this.http.get(this.url+`/ecitation-services/report/dayOfWeekReport`)
  

  }
  getHourlyUsageReport(){
  
    return this.http.get(this.url+`/ecitation-services/report/hourlyUsageReport`)
  

  }
}
